import React from 'react'
import PropTypes from 'prop-types'
import useIntagramGallery from './useIntagramGallery'
import EmblaCarousel from './components/EmblaCarousel'
import { isEmpty } from 'lodash'

InstagramGallery.propTypes = {
  data: PropTypes.object,
}

export default function InstagramGallery({ data }) {
  const { images } = useIntagramGallery({ data })

  if (isEmpty(images)) return null

  return (
    <section className="my-[150px]">
      <div className="main-container flex flex-col mb-9">
        <p className="paragraph uppercase">{data?.subtitle}</p>
        <h4 className="heading2 text-[45px] uppercase">{data?.title}</h4>
      </div>

      <EmblaCarousel slides={images} />
    </section>
  )
}
